export default __webpack_public_path__ + "static/inmemory-a47d98ba69a32ce71c9a2150be50d01a.jpg";